import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { FlexSpace, FormModal } from '@ubeya/shared-web/components';
import { responsiveFields } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import SupplierRatesFields from './SupplierRatesFields';
import SupplierRatesWithEffective from './SupplierRatesWithEffective';

const Container = styled(FlexSpace)`
  margin-top: -30px;
  ${responsiveFields.mobile}
`;

const RateModal = ({
  selectedRate,
  isFlatWage,
  mappedPositions,
  onClose,
  onConfirm,
  markupType,
  isClientControlsRates
}) => {
  const { t } = useContext(ConfigContext);

  const title = useMemo(
    () =>
      `${selectedRate.id ? t('editRate') : t('addRate')}${
        selectedRate.positionId ? ` - ${mappedPositions[selectedRate.positionId]?.label}` : ''
      }`,
    [mappedPositions, selectedRate.id, selectedRate.positionId, t]
  );

  const disableRateEdit = !isClientControlsRates;
  const showWithEffectiveRates = !!selectedRate.positionId;

  return (
    <FormModal
      initialValues={selectedRate}
      onSubmit={(values) => {
        onConfirm(values);
        onClose();
      }}
      isPaddingContent={!showWithEffectiveRates}
      size={showWithEffectiveRates ? 'medium' : 'small'}
      onClose={onClose}
      title={title}
      confirmText={t('save')}
      showCancelButton>
      {showWithEffectiveRates ? (
        <SupplierRatesWithEffective
          isFlatWage={isFlatWage}
          selectedRate={selectedRate}
          markupType={markupType}
          disableRateEdit={disableRateEdit}
        />
      ) : (
        <Container>
          <SupplierRatesFields isFlatWage={isFlatWage} markupType={markupType} disableRateEdit={disableRateEdit} />
        </Container>
      )}
    </FormModal>
  );
};

export default RateModal;
